import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Pedágio (Opcional)",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab
    }
  }, [_c('b-row'), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "valor",
      "label-for": "valor",
      "label": "Valor R$"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "autofocus": ""
    },
    model: {
      value: _vm.form.valor,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valor", $$v);
      },
      expression: "form.valor"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "numero_compra",
      "label-for": "numero_compra",
      "label": "Número Compra"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "50"
    },
    model: {
      value: _vm.form.numero_compra,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "numero_compra", $$v);
      },
      expression: "form.numero_compra"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "tipo_combinacao_veiculo",
      "label-for": "tipo_combinacao_veiculo",
      "label": "Tipo combinação veículo"
    }
  }, [_c('VueSelect', {
    ref: "selectTipoEmissor",
    class: {
      hasErrors: _vm.unidadeError
    },
    attrs: {
      "filterable": false,
      "searchable": false,
      "options": _vm.combinacoesVeiculares
    },
    on: {
      "input": function input() {
        return _vm.unidadeError = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.description) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.description) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.tipo_combinacao_veiculo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tipo_combinacao_veiculo", $$v);
      },
      expression: "form.tipo_combinacao_veiculo"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Selecione o tipo de combinação ")])], 2)], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "tipo_pedagio",
      "label-for": "tipo_pedagio",
      "label": "Tipo de Pedágio"
    }
  }, [_c('VueSelect', {
    ref: "tipo_pedagio",
    class: {
      hasErrors: _vm.tipoPedagioError
    },
    attrs: {
      "filterable": false,
      "searchable": false,
      "options": _vm.tiposPedagio
    },
    on: {
      "input": function input() {
        return _vm.tipoPedagioError = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.tipo_pedagio,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tipo_pedagio", $$v);
      },
      expression: "form.tipo_pedagio"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o tipo de pedágio ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "identificao_responsavel",
      "label-for": "identificao_responsavel",
      "label": "Identificaçao responsável"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['###.###.###-##'],
      expression: "['###.###.###-##']"
    }],
    attrs: {
      "maxlength": "50"
    },
    model: {
      value: _vm.form.identificao_responsavel,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "identificao_responsavel", $$v);
      },
      expression: "form.identificao_responsavel"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "responsavel",
      "label-for": "responsavel",
      "label": "Responsável (CNPJ)"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "responsavel",
      "name": "responsavel"
    },
    nativeOn: {
      "input": function input($event) {
        return _vm.onCpfCnpjInput($event, _vm.form.responsavel, 'cnpj');
      }
    },
    model: {
      value: _vm.form.responsavel.cnpj,
      callback: function callback($$v) {
        _vm.$set(_vm.form.responsavel, "cnpj", $$v);
      },
      expression: "form.responsavel.cnpj"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "observacoes",
      "label": "Informações Complementares",
      "label-for": "observacoes"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "6",
      "max-rows": "6",
      "id": "observacoes",
      "name": "observacoes"
    },
    model: {
      value: _vm.form.observacoes,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "observacoes", $$v);
      },
      expression: "form.observacoes"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };